export const FETCHROLE = '@role/FETCHROLE';
export const CHANGESTATUSROLE = '@role/CHANGESTATUSROLE';
export const DELETEROLE = '@role/DELETEROLE';